module.exports = __webpack_public_path__ + "img/team-2.fac4eea7.jpg";